<template>
    <v-form-field v-bind="$props">
        <template v-slot:append>
            <slot name="append"></slot>
        </template>
        <template v-slot:label-prepend>
            <slot name="label-prepend"></slot>
        </template>
        <template v-slot:label-append>
            <slot name="label-append"></slot>
        </template>
        <template v-slot:label>
            <slot name="label"></slot>
        </template>
        <template v-slot:content>
            <v-textarea :readonly="readonly"
                        class="form-input__border"
                        style="line-height: 5px;"
                        :height="height"
                        :autofocus="autofocus"
                        flat
                        solo
                        :disabled="disable"
                        hide-details dense v-model="textContent"
                        @change="onchange"
            ></v-textarea>
        </template>
    </v-form-field>
</template>
<script>
    export default {
        name: "FormTextAreaField.vue",
        props: {
            small: {
                type: Boolean,
                default: false
            },
            xSmall: {
                type: Boolean,
                default: false
            },
            xxSmall: {
                type: Boolean,
                default: false
            },
            middle: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            xLarge: {
                type: Boolean,
                default: false
            },
            xxLarge: {
                type: Boolean,
                default: false
            },
            label: {
                type: String
            },
            disable: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false
            },
            value: null,
            placeholder: {type: String},
            autofocus: {
                type: Boolean,
                default: false
            },
            labelWidth: {
                type: Number
            },
            fieldWidth: {
                type: Number
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            removeLabel: {
                type: Boolean,
                default: false
            },
            height: {
                type: Number,
                default: 80
            },
            horizontal: {
                type: Boolean,
                default: true
            },
            vertical: {
                type: Boolean,
                default: false
            },
            tip: {
                type: String
            },
        },
        data() {
            return {
                textContent: null
            }
        },
        watch: {
            value(val) {
                this.textContent = val;
            }
        },
        created() {
            this.textContent = this.value;

        },
        methods: {
            onchange(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            }
        }
    }
</script>